<template>
  <b-alert
    show
    class="tw-py-3 lg:tw-px-7 tw-font-medium tw-bg-[#ECE8F5] tw-border-none tw-mb-0 tw-flex tw-justify-center tw-items-center"
  >
    <div>
      <IconCelebrate class="d-inline-block mr-3" />
      <span class="tw-text-md lg:tw-text-xl tw-align-middle tw-font-medium">
        <a
          href="https://shop.bywinona.com/"
          class="tw-underline tw-text-[#1A1A1A]"
          @click.prevent="onClick"
        >HRT + supplements: Give your health regimen a boost! Shop new doctor-curated supplements by Winona.</a>
      </span>
    </div>
  </b-alert>
</template>

<script>
import IconCelebrate from '@/components/icon/IconCelebrate.vue';
import analyticsMixin from '@/mixins/analytics';

export default {
  name: 'NonRxBanner',
  components: {
    IconCelebrate,
  },
  mixins: [analyticsMixin],
  methods: {
    async onClick() {
      await this.$_analytics_track('buttonClicked', { type: 'supplements_banner' });
      window.location.href = 'https://shop.bywinona.com/';
    }
  }
}
</script>